import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import Colors from '../../../themes/Colors';

/**
 * Toggle for subsidizing (bonificar) a price. Collapsed it reads as a gift
 * circle; on hover it grows into a pill showing "Bonificar".
 *
 * @param {boolean}  checked  - whether the price is already subsidized
 * @param {boolean}  disabled
 * @param {node}     tooltip  - what exactly gets subsidized, per call site
 * @param {function} onClick
 */
const SubsidizeButton = ({ checked, disabled, tooltip, onClick }) => {
  const { t } = useTranslation();
  const [hovered, setHovered] = useState(false);

  return (
    <Tooltip placement="top" title={tooltip}>
      {/* `round` the whole time so the corners never snap when the label grows. */}
      <Button
        icon="gift"
        size="small"
        shape="round"
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        disabled={disabled}
        // Inline styles beat antd's disabled look, so only paint it when enabled.
        style={
          disabled
            ? undefined
            : {
                borderColor: Colors.atention,
                color: checked ? '#fff' : Colors.atention,
                background: checked ? Colors.atention : undefined
              }
        }
      >
        <span
          style={{
            display: 'inline-block',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            verticalAlign: 'middle',
            maxWidth: hovered ? '120px' : 0,
            opacity: hovered ? 1 : 0,
            marginLeft: hovered ? '6px' : 0,
            transition:
              'max-width 0.25s ease-in-out, opacity 0.25s ease-in-out, margin-left 0.25s ease-in-out'
          }}
        >
          {t('Subsidize')}
        </span>
      </Button>
    </Tooltip>
  );
};

export default SubsidizeButton;
